var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as customPropTypes from './customPropTypes';
export var createCommon = function (config) {
    if (config === void 0) { config = {}; }
    var _a = config.animated, animated = _a === void 0 ? true : _a, _b = config.as, as = _b === void 0 ? true : _b, _c = config.children, children = _c === void 0 ? 'node' : _c, _d = config.className, className = _d === void 0 ? true : _d, _e = config.color, color = _e === void 0 ? false : _e, _f = config.content, content = _f === void 0 ? 'node' : _f, _g = config.styled, styled = _g === void 0 ? true : _g;
    return __assign({}, (animated && {
        animation: customPropTypes.animation,
    }), (as && {
        as: customPropTypes.as,
    }), (children && {
        children: children === 'element' ? PropTypes.element : PropTypes.node,
    }), (className && {
        className: PropTypes.string,
    }), (color && {
        color: PropTypes.oneOfType([
            PropTypes.oneOf([
                'primary',
                'secondary',
                'blue',
                'green',
                'grey',
                'orange',
                'pink',
                'purple',
                'teal',
                'red',
                'yellow',
            ]),
            PropTypes.string,
        ]),
    }), (content && {
        content: content === 'shorthand' ? customPropTypes.itemShorthand : customPropTypes.nodeContent,
    }), (styled && {
        styles: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
        variables: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    }));
};
